import { combineReducers } from 'redux';

import apiError from './apiError';
import data from './data';
import isLoading from './isLoading';

/**
 * @typedef {{
 *   data: Record<string, Record<string, string>>,
 *   isLoading: boolean,
 *   apiError: string,
* }} AuditModelUIDetailsTranslationReducer
*/

export default combineReducers({
  data,
  isLoading,
  apiError,
});
